import React from "react";
import { getInitials } from "../../../utils/formatters";

export const AvatarDisplay = ({ profilePictureUrl, name }) => {
  return (
    <div className="w-full h-full rounded-full overflow-hidden">
      {profilePictureUrl ? (
        <img
          src={profilePictureUrl}
          alt={name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      ) : name ? (
        <div className="w-full h-full bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center">
          <span className="text-slate-600 font-bold text-[10px]">
            {getInitials(name)}
          </span>
        </div>
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center">
          <svg
            className="w-full h-full text-slate-400"
            viewBox="0 0 100 100"
            fill="currentColor"
          >
            <circle cx="50" cy="35" r="18" />
            <path d="M50 58 C 25 58, 10 65, 10 100 L 90 100 C 90 65, 75 58, 50 58 Z" />
          </svg>
        </div>
      )}
    </div>
  );
};